import React from "react";
import PropTypes from "prop-types";
import HotTable from "react-handsontable";
import axios from "axios";

class PoolImporter extends React.Component {
  state = {
    pools: [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ],
    colHeaders: [
      "Location *",
      "Name *",
      "Type",
      "Notes",
      "Volume (gal)",
      "Free Chlorine Visible",
      "Free Chlorine Low Alert (ppm)",
      "Free Chlorine High Alert (ppm)",
      "Total Chlorine Visible",
      "Total Chlorine Low Alert (ppm)",
      "Total Chlorine High Alert (ppm)",
      "Total Bromine Visible",
      "Total Bromine Low Alert (ppm)",
      "Total Bromine High Alert (ppm)",
      "pH Visible",
      "pH Low Alert",
      "pH High Alert",
      "Pool Temp Visible",
      "Ideal Pool Temperature",
      "Pool Temp Low Alert (F)",
      "Pool Temp High Alert (F)",
      "Inc. Chlorine Chemical",
      "Inc. Total Alkalinity Chemical",
      "Dec. Total Alkalinity Chemical",
      "Inc. Calcium Hardness Chemical",
      "Inc. Stabilizer Chemical",
      "Neutralize Chlorine Chemical",
      "HRR / ORP Visible",
      "Alkalinity Visible",
      "Calcium Hardness Visible",
      "Air Temp Visible",
      "Water Clarity Visible",
      "Backwash Visible",
      "Notes Visible",
      "Custom Field One Name",
      "Custom Field Two Name",
      "Custom Field Three Name",
      "Custom Field Four Name",
      "Custom Field Five Name",
      "Custom Field Six Name",
      "Custom Field Seven Name",
      "Custom Field Eight Name",
      "Custom Field Nine Name",
      "Custom Field Ten Name",
      "Custom Field Eleven Name",
      "Custom Field Twelve Name"
    ]
  };

  importPools = () => {
    let that = this;

    axios
      .post("/pools_import", {
        pools: that.state.pools
      })
      .then(function(response) {
        toastr.success(
          "Pools have been imported, please check your email for confirmation"
        );
      })
      .catch(function(error) {
        toastr.error("Pools not imported, check your email for errors");
        console.log(error);
      });
  };

  addRows = () => {
    let rows = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    let pools = this.state.pools;

    this.setState({ pools: pools.concat(rows) });
    toastr.success("Rows added");
  };

  reset = () => {
    let pools = [
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {}
    ];

    this.setState({ pools: pools });
    toastr.success("Grid has been cleared");
  };

  render() {
    let that = this;
    const width = { width: "1100px" };

    let columns = [
      {
        data: "locationName",
        type: "dropdown",
        source: _.map(_.sortBy(this.props.locations, ["name"]), "name")
      },
      {
        data: "name",
        type: "text"
      },
      {
        data: "type",
        type: "dropdown",
        source: ["Indoor Pool", "Indoor Spa", "Outdoor Pool", "Outdoor Spa"],
        strict: true
      },
      {
        data: "notes",
        type: "text"
      },
      {
        data: "volume",
        type: "numeric"
      },
      {
        data: "freeChlorineToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "freeChlorineLowAlert",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "freeChlorineHighAlert",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "totalChlorineToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "totalChlorineLowAlert",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "totalChlorineHighAlert",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "totalBromineToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "totalBromineLowAlert",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "totalBromineHighAlert",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "pHToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "pHLowAlert",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "pHHighAlert",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "poolTempToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "idealPoolTemp",
        type: "numeric",
        format: "0.0"
      },
      {
        data: "poolTempLowAlert",
        type: "numeric",
        format: "0.00"
      },
      {
        data: "poolTempHighAlert",
        type: "numeric",
        format: "0.00"
      },
      {
        data: "increaseChlorineChemical",
        type: "dropdown",
        source: [
          "Chlorine Gas",
          "Calcium Hypochlorite (67%)",
          "Sodium Hypochlorite (12%)",
          "Lihium Hypochlorite",
          "Dichlor (62%)",
          "Dichlor (56%)",
          "Trichlor"
        ],
        strict: true
      },
      {
        data: "increaseTotalAlkalinityChemical",
        type: "dropdown",
        source: [
          "Sodium Bicarbonate",
          "Sodium Carbonate",
          "Sodium Sesquicarbonate"
        ],
        strict: true
      },
      {
        data: "decreaseTotalAlkalinityChemical",
        type: "dropdown",
        source: ["Muriatic Acid (31.4%)", "Sodium Bisulfate"],
        strict: true
      },
      {
        data: "increaseCalciumHardnessChemical",
        type: "dropdown",
        source: ["Calcium Chloride (100%)", "Calcium Chloride (77%)"],
        strict: true
      },
      {
        data: "increaseStabilizerChemical",
        type: "dropdown",
        source: ["Cyanuric Acid"],
        strict: true
      },
      {
        data: "neutralizeChlorineChemical",
        type: "dropdown",
        source: ["Sodium Thiosulfate Acid", "Sodium Sulfite"],
        strict: true
      },
      {
        data: "HRRORPToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "alkalinityToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "calciumHardnessToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "airTempToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "waterClarityToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "backwashToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "notesToggle",
        type: "dropdown",
        source: ["Yes", "No"]
      },
      {
        data: "customFieldOneName",
        type: "text"
      },
      {
        data: "customFieldTwoName",
        type: "text"
      },
      {
        data: "customFieldThreeName",
        type: "text"
      },
      {
        data: "customFieldFourName",
        type: "text"
      },
      {
        data: "customFieldFiveName",
        type: "text"
      },
      {
        data: "customFieldSixName",
        type: "text"
      },
      {
        data: "customFieldSevenName",
        type: "text"
      },
      {
        data: "customFieldEightName",
        type: "text"
      },
      {
        data: "customFieldNineName",
        type: "text"
      },
      {
        data: "customFieldTenName",
        type: "text"
      },
      {
        data: "customFieldElevenName",
        type: "text"
      },
      {
        data: "customFieldTwelveName",
        type: "text"
      }
    ];

    return (
      <div>
        <h1>Pools Importer</h1>
        <p style={width}>
          Copy and paste your pool data from Excel to add them into DigiQuatics.
          <br />
          Don't have an Excel file already? Download our template
          <a
            className="styled-link"
            href="/download_excel_template.xlsx?template=pools_importer"
          >
            {" "}
            here{" "}
          </a>
          to get started.
        </p>
        <br />
        <a
          className="btn btn-pink btn-raised btn-long margin-right-five"
          onClick={() => that.importPools()}
        >
          IMPORT
        </a>
        <a
          className="btn btn-indigo btn-raised btn-long margin-right-five"
          onClick={() => that.addRows()}
        >
          ADD ROWS
        </a>
        <a
          className="btn btn-grey btn-raised btn-long"
          onClick={() => that.reset()}
        >
          RESET
        </a>
        <br />
        <br />
        <HotTable
          root="hot"
          data={this.state.pools}
          colHeaders={true}
          rowHeaders={false}
          colWidths={[
            200,
            150,
            150,
            400,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            180,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125,
            125
          ]}
          width={1200}
          height={500}
          colHeaders={this.state.colHeaders}
          columns={columns}
        />
      </div>
    );
  }
}

PoolImporter.propTypes = {
  locations: PropTypes.array
};

export default PoolImporter;
